import { useState } from "react";
import { Box, Typography, TextField, Button, IconButton, InputAdornment } from "@mui/material";
import { tokens } from "../../theme";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import logo from "../../imgs/logo.png"; 
import axios from "axios";
import { useNavigate } from 'react-router-dom';


const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [form, setForm] = useState({ email: "", password: "" });
  const navigate = useNavigate();
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

    const handleLogin = async () => {
      try {
        const response = await axios.post("https://store.petplanet.rw/api/login", form, {
          headers: {
            "Content-Type": "application/json",
          },
        });
    
        const data = response.data;
        localStorage.setItem("authToken", "someTokenValue");
        navigate("/dashboard");
        console.log("Login success:", data);
      } catch (error) {
        if (error.response) {
          // Server responded with an error
          alert(error.response.data.error || "Login failed");
        } else {
          // Network or other issue
          console.error("Login error:", error);
          alert("Something went wrong");
        }
      }
    };


  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection:"column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: tokens.grey[200],
      }}
    >
        
      <Box
        sx={{
          width: "380px",
          p: 4,
          borderRadius: 2,
          boxShadow: "0 6px 18px rgba(0,0,0,0.06)",
          backgroundColor: tokens.grey[100],
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <img src={logo}
              alt="logo"
              width="100%"
              height="100px"
              style={{ cursor: "pointer" }}
        />
        <TextField
          label="Enter your email"
          name="email"
          value={form.email}
          onChange={handleChange}
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              height: 40,
              "& .MuiInputBase-input": {
                fontSize: "0.8rem",
                padding: "8px 12px",
                paddingLeft: "10px"
              },
              "& fieldset": { borderColor: tokens.grey[400] },
              "&:hover fieldset": { borderColor: tokens.blueAccent[300] },
              "&.Mui-focused fieldset": { borderColor: tokens.blueAccent[300] },
            },
            "& .MuiInputLabel-root": {
                paddingLeft: "16px", 
              fontSize: "12px",
              top: 9, // adjust vertical position of label
              transform: "translate(0, 0)", // remove default translation
            },
            "& .MuiInputLabel-shrink": {
              transform: "translate(0, -18px) ", // adjust when label shrinks
            },
          }}
        />
        

        <TextField
          label="Password"
          name="password"
          type={showPassword ? "text" : "password"}
          value={form.password}
          onChange={handleChange}
          variant="outlined"
          sx={{
            "& .MuiOutlinedInput-root": {
              height: 40,
              "& .MuiInputBase-input": {
                fontSize: "0.8rem",
                padding: "8px 12px",
                paddingLeft: "10px"
              },
              "& fieldset": { borderColor: tokens.grey[400] },
              "&:hover fieldset": { borderColor: tokens.blueAccent[300] },
              "&.Mui-focused fieldset": { borderColor: tokens.blueAccent[300] },
            },
            "& .MuiInputLabel-root": {
                paddingLeft: "16px", 
              fontSize: "12px",
              top: 9, // adjust vertical position of label
              transform: "translate(0, 0)", // remove default translation
            },
            "& .MuiInputLabel-shrink": {
              transform: "translate(0, -18px) ", // adjust when label shrinks
            },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  sx={{
                    width: "28px",        // smaller button width
                    height: "28px",
                  }} 
                  onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <VisibilityOff sx={{ fontSize: "18px" }} /> : <Visibility sx={{ fontSize: "18px" }} />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Button
          variant="contained"
          sx={{
            backgroundColor: tokens.redAccent[400],
            color: tokens.grey[100],
            fontWeight: 600,
            "&:hover": {
              backgroundColor: tokens.redAccent[400],
            },
          }}
          onClick={handleLogin}
        >
          Login
        </Button>

        <Typography
          variant="body2"
          sx={{ textAlign: "center", color: tokens.grey[500] }}
        >
          Forgot your password?
        </Typography>
      </Box>
    </Box>
  );
};

export default LoginPage;
